import React,{Component}  from 'react';
import 'antd-mobile/dist/antd-mobile.css'; 
import 'antd-mobile/lib/date-picker/style'; 
import {connect} from 'dva';

class NoInweixin extends Component {
    constructor(props){
        super(props);
        this.state ={
            
        }
    }
    componentDidMount() {
       
      }
    render(){
        return(<div  >
           只能在微信环境使用

      </div>);
    }

}

export default connect()(NoInweixin) ;